import React from 'react'
import moment from 'moment'
import CalendarMonthList from './CalendarMonthList'
import {
  mergeInstances,
  attachCatalogUrls,
  isNonMobileSchedulePlatform,
  getSchedulesList,
  enrichInstancesWithLocalCompletions,
  expandInstrumentsByInstances,
} from '../utils/instrumentUtils'
import {
  shouldHideUnconfirmedVisitInstrument,
  shouldKeepInstrumentInCalendarPending,
} from '../utils/calendarInstrumentUtils'
import { compareDates } from '../../../utils/time'
import { getLine } from '../utils/calendarUtils'
import { INSTRUMENT_DISPLAY_LOCATION_OPTIONS } from 'utils/constants'

const CalendarInstrumentsList = ({
  allInstances,
  availableInstances,
  displayingList,
  fetchInstrument,
  formatSubmissionSurvey,
  fullMonthList,
  futureInstances,
  humiIsabellaDisabled,
  leftArrowDisabled,
  monthList,
  onLeftArrowClick,
  onRightArrowClick,
  rightArrowDisabled,
  selectMonth,
  selectedMonth,
  selectDay,
  selectedDay,
  strings,
  sendEvent,
  selectedLocale,
  setSubmissionSurvey,
  studyId,
  selectedLine,
  selectLine,
  participantId,
  firstLogin,
  confirmedVisitKeys = [],
}) => {
  const hasCalendarDisplayLocation = metadata => {
    const displayLocation = metadata?.display_location

    // Backwards compatibility: if no display_location is defined,
    // treat the instrument as visible in the calendar.
    if (!displayLocation) return true

    return displayLocation.includes(
      INSTRUMENT_DISPLAY_LOCATION_OPTIONS.calendar
    )
  }

  const hasExpiringSchedule = (metadata) => {
    const schedules = getSchedulesList(metadata?.schedule)
    if (!schedules.length) return false
    return schedules.some((schedule) => schedule?.expire?.never !== null)
  }

  const instancesWithLocalCompletions = enrichInstancesWithLocalCompletions(
    allInstances,
    participantId,
  )

  const expiredInstruments = attachCatalogUrls(
    instancesWithLocalCompletions
      .filter(
        ({ metadata }) =>
          hasExpiringSchedule(metadata) &&
          hasCalendarDisplayLocation(metadata),
      )
      .filter(isNonMobileSchedulePlatform),
    displayingList,
  )
  const completedInstruments = attachCatalogUrls(
    instancesWithLocalCompletions
      .filter(({ instances }) =>
        instances?.some((instance) => !!instance.completion)
      )
      .filter(({ metadata }) => hasCalendarDisplayLocation(metadata))
      .filter(isNonMobileSchedulePlatform),
    displayingList,
  )

  const availableInstruments = attachCatalogUrls(
    expandInstrumentsByInstances(
      mergeInstances(
        mergeInstances(futureInstances, availableInstances),
        instancesWithLocalCompletions,
      )
        .filter(({ instrument_type }) => instrument_type !== 'ANNOUNCEMENT')
        .filter(({ metadata }) => hasCalendarDisplayLocation(metadata))
        .filter(isNonMobileSchedulePlatform)
        .filter(
          (instrument) =>
            !shouldHideUnconfirmedVisitInstrument(
              instrument?.metadata?.schedule,
              instrument?.instances,
              confirmedVisitKeys,
            ),
        ),
    ).filter(shouldKeepInstrumentInCalendarPending),
    displayingList,
  )

  return (
    <div className='calendar-instruments-list'>
      <div className='calendar-mode-header-box'>
        <div className='calendar-mode-header'>
          {strings.calendar || 'Calendar'}
        </div>
        <div className='calendar-mode-toggle'>
          <div
            className={`calendar-mode-toggle-option ${selectedLine !== 0 ? 'selected' : ''
              }`}
            onClick={() => {
              const today = moment()
              const currentMonth =
                fullMonthList?.find(
                  (item) =>
                    item?.value === today.month() + 1 &&
                    item?.year === today.year(),
                ) || selectedMonth
              if (currentMonth) {
                selectMonth(currentMonth)
              }
              selectDay(today)
              selectLine(getLine(today.date() - 1))
            }}>
            {strings.week_view || 'Week view'}
          </div>
          <div className='calendar-mode-toggle-separator' />
          <div
            className={`calendar-mode-toggle-option ${selectedLine === 0 ? 'selected' : ''
              }`}
            onClick={() => {
              selectLine(0)
              selectDay('')
            }}>
            {strings.month_view || 'Month view'}
          </div>
        </div>
      </div>
      <div className='calendar-current-month'>{selectedMonth?.longName}</div>
      <CalendarMonthList
        monthList={monthList}
        fullMonthList={fullMonthList}
        selectedMonth={selectedMonth}
        selectMonth={selectMonth}
        selectDay={selectDay}
        selectedDay={selectedDay}
        formatSubmissionSurvey={formatSubmissionSurvey}
        strings={strings}
        sendEvent={sendEvent}
        selectedLocale={selectedLocale}
        fetchInstrument={fetchInstrument}
        setSubmissionSurvey={setSubmissionSurvey}
        displayingList={displayingList}
        humiIsabellaDisabled={humiIsabellaDisabled}
        onLeftArrowClick={onLeftArrowClick}
        onRightArrowClick={onRightArrowClick}
        leftArrowDisabled={leftArrowDisabled}
        rightArrowDisabled={rightArrowDisabled}
        expiredInstruments={expiredInstruments}
        completedInstruments={completedInstruments}
        availableInstruments={availableInstruments}
        allInstances={instancesWithLocalCompletions}
        studyId={studyId}
        selectedLine={selectedLine}
        selectLine={selectLine}
        participantId={participantId}
        firstLogin={firstLogin}
        confirmedVisitKeys={confirmedVisitKeys}
      />
    </div>
  )
}

export default CalendarInstrumentsList
